import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/categories";

const footerGroups = [
  {
    title: "Fashion",
    items: categories.slice(0, 5),
  },
  {
    title: "Accessories",
    items: categories.slice(5, 10),
  },
  {
    title: "More",
    items: categories.slice(10),
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerGroups.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {group.title}
              </h4>
              <ul className="space-y-2.5">
                {group.items.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/60 hover:text-background-50/90 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
              GTBuy.PRO
            </h4>
            <p className="text-sm text-background-50/60 mb-4">
              Your smart shopping spreadsheet hub. Compare prices, find deals, shop smarter.
            </p>
            <Link
              to="/"
              className="text-sm text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap"
            >
              ← Back to Home
            </Link>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="font-heading text-lg font-bold text-background-50">
              GTBuy<span className="text-accent-400">.PRO</span>
            </span>
          </div>

          <p className="text-xs text-background-50/40 text-center">
            &copy; {new Date().getFullYear()} GTBuy.PRO. All rights reserved.{" "}
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="hover:text-background-50/70 transition-colors"
            >
              Visit Main Site
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}